import React from "react";
import { useLists } from "../../context/listContext";
import { DashBox, DashMain } from "../../styles/index.sty";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import GroupIcon from "@mui/icons-material/Group";
import CategoryIcon from "@mui/icons-material/Category";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import StarPurple500Icon from "@mui/icons-material/StarPurple500";
import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "../../context/authContext";

const Dashboard = () => {
  const { countList, fetchCountsList } = useLists();

  const { userType } = useAuth();

  useEffect(() => {
    fetchCountsList();
  }, []);
  const navigate = useNavigate();
  // console.log(brandsList);
  return (
    <DashMain>
      {userType.toUpperCase() === "SALES ADMIN" ? (
        <>
          <Tooltip title="Visit Orders Page">
            <DashBox onClick={() => navigate("/orders")}>
              <div>
                <h2>Orders</h2>
                <br />
                <h3>
                  Total Count: <span>{countList[0]?.orders_count || 0}</span>
                </h3>
              </div>
              <div>
                <StarPurple500Icon />
              </div>
            </DashBox>
          </Tooltip>
          <Tooltip title="Visit Analytics Page">
            <DashBox onClick={() => navigate("/analytics")}>
              <div>
                <h2>Analytics</h2>
                <br />
                <h3>
                  Total Count: <span>{countList[0]?.orders_count || 0}</span>
                </h3>
              </div>
              <div>
                <StarPurple500Icon />
              </div>
            </DashBox>
          </Tooltip>
        </>
      ) : userType.toUpperCase() === "POST ADMIN" ? (
        <>
          <Tooltip title="Visit Product Categories Bar Page">
            <DashBox onClick={() => navigate("/product-categories-bars")}>
              <div>
                <h2>Product Categories Bars</h2>
                <br />
                <h3>
                  Total Count:{" "}
                  <span>{countList[0]?.category_bar_count || 0}</span>
                </h3>
              </div>
              <div>
                <CategoryIcon />
              </div>
            </DashBox>
          </Tooltip>
          <Tooltip title="Visit Product Categories Page">
            <DashBox onClick={() => navigate("/product-categories")}>
              <div>
                <h2>Product Categories</h2>
                <br />
                <h3>
                  Total Count: <span>{countList[0]?.category_count || 0}</span>
                </h3>
              </div>
              <div>
                <CategoryIcon />
              </div>
            </DashBox>
          </Tooltip>
          <Tooltip title="Visit Product Sub Categories Page">
            <DashBox onClick={() => navigate("/product-sub-categories")}>
              <div>
                <h2>Sub-Categories</h2>
                <br />
                <h3>
                  Total Count:{" "}
                  <span>{countList[0]?.sub_category_count || 0}</span>
                </h3>
              </div>
              <div>
                <CategoryIcon />
              </div>
            </DashBox>
          </Tooltip>
          <Tooltip title="Visit Product Sub Categories Page">
            <DashBox onClick={() => navigate("/attributes")}>
              <div>
                <h2>Attributes</h2>
                <br />
                <h3>
                  Total Count:{" "}
                  <span>
                    {countList[0]?.finish_count +
                      countList[0]?.size_count +
                      countList[0]?.storage_count +
                      countList[0]?.color_count +
                      countList[0]?.material_count || 0}
                  </span>
                </h3>
              </div>
              <div>
                <CategoryIcon />
              </div>
            </DashBox>
          </Tooltip>
          <Tooltip title="Visit Products Page">
            <DashBox onClick={() => navigate("/products")}>
              <div>
                <h2>Products</h2>
                <br />
                <h3>
                  Total Count: <span>{countList[0]?.product_count || 0}</span>
                </h3>
              </div>
              <div>
                <ShoppingCartCheckoutIcon />
              </div>
            </DashBox>
          </Tooltip>
          <Tooltip title="Visit City Page">
            <DashBox onClick={() => navigate("/city")}>
              <div>
                <h2>City</h2>
                <br />
                <h3>
                  Total Count: <span>{countList[0]?.city_count || 0}</span>
                </h3>
              </div>
              <div>
                <StarPurple500Icon />
              </div>
            </DashBox>
          </Tooltip>
          <Tooltip title="Visit Store Page">
            <DashBox onClick={() => navigate("/store")}>
              <div>
                <h2>Store</h2>
                <br />
                <h3>
                  Total Count: <span>{countList[0]?.store_count || 0}</span>
                </h3>
              </div>
              <div>
                <StarPurple500Icon />
              </div>
            </DashBox>
          </Tooltip>
          <Tooltip title="Visit Testimonial Page">
            <DashBox onClick={() => navigate("/testimonials")}>
              <div>
                <h2>Testimonial</h2>
                <br />
                <h3>
                  Total Count:{" "}
                  <span>{countList[0]?.testimonial_count || 0}</span>
                </h3>
              </div>
              <div>
                <StarPurple500Icon />
              </div>
            </DashBox>
          </Tooltip>
        </>
      ) : userType.toUpperCase() === "MARKETING ADMIN" ? (
        <>
          <Tooltip title="Visit Blog Page">
            <DashBox onClick={() => navigate("/blog")}>
              <div>
                <h2>Blog</h2>
                <br />
                <h3>
                  Total Count: <span>{countList[0]?.blog_count || 0}</span>
                </h3>
              </div>
              <div>
                <StarPurple500Icon />
              </div>
            </DashBox>
          </Tooltip>
          <Tooltip title="Visit Slider Page">
            <DashBox onClick={() => navigate("/slider")}>
              <div>
                <h2>Slider</h2>
                <br />
                <h3>
                  Total Count: <span>{countList[0]?.slider_count || 0}</span>
                </h3>
              </div>
              <div>
                <StarPurple500Icon />
              </div>
            </DashBox>
          </Tooltip>
          <Tooltip title="Visit Products Page">
            <DashBox onClick={() => navigate("/reviews")}>
              <div>
                <h2>Rating & Reviews</h2>
                <br />
                <h3>
                  Total Count:{" "}
                  <span>{countList[0]?.rating_and_reviews_count || 0}</span>
                </h3>
              </div>
              <div>
                <StarPurple500Icon />
              </div>
            </DashBox>
          </Tooltip>
          <Tooltip title="Visit Users Page">
            <DashBox onClick={() => navigate("/users")}>
              <div>
                <h2>Users</h2>
                <br />
                <h3>
                  Total Count: <span>{countList[0]?.user_count || 0}</span>
                </h3>
              </div>
              <div>
                <GroupIcon />
              </div>
            </DashBox>
          </Tooltip>
        </>
      ) : userType.toUpperCase() === "SUPER ADMIN" ? (
        <>
          <Tooltip title="Visit Admins Page">
            <DashBox onClick={() => navigate("/admins")}>
              <div>
                <h2>Admins</h2>
                <br />
                <h3>
                  Total Count: <span>{countList[0]?.admin_count || 0}</span>
                </h3>
              </div>
              <div>
                <AdminPanelSettingsIcon />
              </div>
            </DashBox>
          </Tooltip>
          <Tooltip title="Visit Users Page">
            <DashBox onClick={() => navigate("/users")}>
              <div>
                <h2>Users</h2>
                <br />
                <h3>
                  Total Count: <span>{countList[0]?.user_count || 0}</span>
                </h3>
              </div>
              <div>
                <GroupIcon />
              </div>
            </DashBox>
          </Tooltip>
          {/* <Tooltip title="Visit User Types Page">
        <DashBox onClick={() => navigate("/user-types")}>
          <div>
            <h2>User Types</h2>
            <br />
            <h3>
              Total Count: <span>{(countList[0]?.user_type_count) || 0}</span>
            </h3>
          </div>
          <div>
            <GroupIcon />
          </div>
        </DashBox>
      </Tooltip> */}
          <Tooltip title="Visit Product Categories Bar Page">
            <DashBox onClick={() => navigate("/product-categories-bars")}>
              <div>
                <h2>Product Categories Bars</h2>
                <br />
                <h3>
                  Total Count:{" "}
                  <span>{countList[0]?.category_bar_count || 0}</span>
                </h3>
              </div>
              <div>
                <CategoryIcon />
              </div>
            </DashBox>
          </Tooltip>
          <Tooltip title="Visit Product Categories Page">
            <DashBox onClick={() => navigate("/product-categories")}>
              <div>
                <h2>Product Categories</h2>
                <br />
                <h3>
                  Total Count: <span>{countList[0]?.category_count || 0}</span>
                </h3>
              </div>
              <div>
                <CategoryIcon />
              </div>
            </DashBox>
          </Tooltip>
          <Tooltip title="Visit Product Sub Categories Page">
            <DashBox onClick={() => navigate("/product-sub-categories")}>
              <div>
                <h2>Sub-Categories</h2>
                <br />
                <h3>
                  Total Count:{" "}
                  <span>{countList[0]?.sub_category_count || 0}</span>
                </h3>
              </div>
              <div>
                <CategoryIcon />
              </div>
            </DashBox>
          </Tooltip>
          <Tooltip title="Visit Product Sub Categories Page">
            <DashBox onClick={() => navigate("/attributes")}>
              <div>
                <h2>Attributes</h2>
                <br />
                <h3>
                  Total Count:{" "}
                  <span>
                    {countList[0]?.finish_count +
                      countList[0]?.size_count +
                      countList[0]?.storage_count +
                      countList[0]?.color_count +
                      countList[0]?.material_count || 0}
                  </span>
                </h3>
              </div>
              <div>
                <CategoryIcon />
              </div>
            </DashBox>
          </Tooltip>
          <Tooltip title="Visit Products Page">
            <DashBox onClick={() => navigate("/products")}>
              <div>
                <h2>Products</h2>
                <br />
                <h3>
                  Total Count: <span>{countList[0]?.product_count || 0}</span>
                </h3>
              </div>
              <div>
                <ShoppingCartCheckoutIcon />
              </div>
            </DashBox>
          </Tooltip>
          <Tooltip title="Visit Products Page">
            <DashBox onClick={() => navigate("/reviews")}>
              <div>
                <h2>Rating & Reviews</h2>
                <br />
                <h3>
                  Total Count:{" "}
                  <span>{countList[0]?.rating_and_reviews_count || 0}</span>
                </h3>
              </div>
              <div>
                <StarPurple500Icon />
              </div>
            </DashBox>
          </Tooltip>
          <Tooltip title="Visit Orders Page">
            <DashBox onClick={() => navigate("/orders")}>
              <div>
                <h2>Orders</h2>
                <br />
                <h3>
                  Total Count: <span>{countList[0]?.orders_count || 0}</span>
                </h3>
              </div>
              <div>
                <StarPurple500Icon />
              </div>
            </DashBox>
          </Tooltip>
          <Tooltip title="Visit Analytics Page">
            <DashBox onClick={() => navigate("/analytics")}>
              <div>
                <h2>Analytics</h2>
                <br />
                <h3>
                  Total Count: <span>{countList[0]?.orders_count || 0}</span>
                </h3>
              </div>
              <div>
                <StarPurple500Icon />
              </div>
            </DashBox>
          </Tooltip>
          <Tooltip title="Visit City Page">
            <DashBox onClick={() => navigate("/city")}>
              <div>
                <h2>City</h2>
                <br />
                <h3>
                  Total Count: <span>{countList[0]?.city_count || 0}</span>
                </h3>
              </div>
              <div>
                <StarPurple500Icon />
              </div>
            </DashBox>
          </Tooltip>
          <Tooltip title="Visit Slider Page">
            <DashBox onClick={() => navigate("/slider")}>
              <div>
                <h2>Slider</h2>
                <br />
                <h3>
                  Total Count: <span>{countList[0]?.slider_count || 0}</span>
                </h3>
              </div>
              <div>
                <StarPurple500Icon />
              </div>
            </DashBox>
          </Tooltip>
          <Tooltip title="Visit Store Page">
            <DashBox onClick={() => navigate("/store")}>
              <div>
                <h2>Store</h2>
                <br />
                <h3>
                  Total Count: <span>{countList[0]?.store_count || 0}</span>
                </h3>
              </div>
              <div>
                <StarPurple500Icon />
              </div>
            </DashBox>
          </Tooltip>
          <Tooltip title="Visit Blog Page">
            <DashBox onClick={() => navigate("/blog")}>
              <div>
                <h2>Blog</h2>
                <br />
                <h3>
                  Total Count: <span>{countList[0]?.blog_count || 0}</span>
                </h3>
              </div>
              <div>
                <StarPurple500Icon />
              </div>
            </DashBox>
          </Tooltip>
          <Tooltip title="Visit Testimonial Page">
            <DashBox onClick={() => navigate("/testimonials")}>
              <div>
                <h2>Testimonial</h2>
                <br />
                <h3>
                  Total Count:{" "}
                  <span>{countList[0]?.testimonial_count || 0}</span>
                </h3>
              </div>
              <div>
                <StarPurple500Icon />
              </div>
            </DashBox>
          </Tooltip>
        </>
      ) : null}
    </DashMain>
  );
};

export default Dashboard;
